import { initialize } from "store/create";
import { initializeGoogle } from "utils/search/autocomplete";
import { TrackingClient } from "@sparefoot/tracking-client";
import { ReactSegmentWrapper } from "@sparefoot/segment-react-wrapper";

export default ({ dispatch, getState }) => {
	const { app, user } = getState();

	TrackingClient.initialize(
		new ReactSegmentWrapper({
			writeKey: app.segmentWriteKey,
			visitId: user.visitId,
			environment: app.environment,
			siteId: 424,
			cdnURL: app.eventsCdnUrl,
			siteType: "desktop",
			integrations: {
				"Segment.io": {
					apiHost: app.eventsApiUrl
				}
			},
			debug:
				process.env.NODE_ENV === "development" &&
				process.env.RENDER_ENV === "client"
		})
	);

	initializeGoogle({
		key: app.googleMapsKey
	});

	dispatch(initialize());
};
